import ResourceLookup from '../ResourceLookup/ResourceLookup';

function UserLookup(props) {
  return <ResourceLookup {...props} labelKey="full_name" resource="user" />;
}

export default UserLookup;
